import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import ClassNames from 'classnames';
import './index.scss';

class Textarea extends React.Component {
  static displayName = 'Textarea';

  static propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.string,
    errors: PropTypes.array,
    placeholder: PropTypes.string,
    theme: PropTypes.string,
  };

  static defaultProps = {
    errors: [],
    onChange: null,
    placeholder: null,
    value: null,
    theme: 'Default',
  };

  _hasError = () => {
    return this.props.errors.length > 0;
  };

  onChangeProxy = (e) => {
    this.props.onChange(this.props.name, e.target.value, e);
  };

  _textareaWrapperClasses = () => {
    return ClassNames('ui', 'input', _.str.sprintf('t-%s', this.props.theme), {
      error: this._hasError(),
    });
  };

  render() {
    return (
      <div className={this._textareaWrapperClasses()} ref="textarea_wrapper">
        <textarea
          className="ui textarea"
          name={this.props.name}
          placeholder={this.props.placeholder}
          ref="textarea"
          onChange={this.onChangeProxy}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
          value={this.props.value}
          data-testid="text-area"
          aria-label={this.props.ariaLabel}
          aria-labelledby={this.props.ariaLabelledBy}
        />

        {this._hasError() && (
          <span className="input-error">{this.props.errors[0]}</span>
        )}
      </div>
    );
  }
}

export default Textarea;
